import { Component } from 'react';
import {connect} from "react-redux";
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import validator from 'validator';

class Validator extends Component {
  componentDidMount() {
    const nextRoute = this.getMissingStep();

    if(nextRoute) {
      return this.props.history.push(nextRoute);
    }
  }

  getMissingStep() {
    if(!this.props.recipientEmail || !validator.isEmail(this.props.recipientEmail)) {
      this.errorToast("Invalid recipient email address");
      return '/recipient';
    } else if (!this.props.giftAmount || !validator.isDecimal('' + this.props.giftAmount)) {
      this.errorToast("Invalid gift amount");
      return '/budget';
    } else if (!this.props.template || !validator.isLength(this.props.template, {min: 1})) {
      this.errorToast("Must choose a theme.");
      return '/theme';
    } else if (!this.props.note || !validator.isLength(validator.trim(this.props.note), {min: 1})) {
      this.errorToast("A note to recipient is required");
      return '/personalize';
    } else if(!this.props.senderEmail || !validator.isEmail(this.props.senderEmail)) {
      this.errorToast("Invalid sender email address.");
      return '/personalize';
    }
    return null;
  }
  errorToast(text) {
    toast.info(text);
  }
  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  recipientEmail: state.gift.recipientEmail,
  senderEmail: state.gift.senderEmail,
  giftAmount: state.gift.giftAmount,
  template: state.gift.template,
  note: state.gift.note,
  wallet: state.wallet
});

export default connect(mapStateToProps)(withRouter(Validator));


// WEBPACK FOOTER //
// ./src/Containers/Validator.js